// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3QXQK","requiredAsterisk":"Info_requiredAsterisk__3zY5C"};